<template>
  <div>
    <home-header></home-header>
    <router-view></router-view>
    <home-footer></home-footer>
  </div>
</template>

<script>
  import HomeHeader from './components/home/header/HomeHeader.vue'
  import HomeFooter from './components/home/footer/HomeFooter.vue'
  export default {
    data () {
      return {
        status: false
      }
    },
    components: {
      HomeHeader,
      HomeFooter
    }
  }
</script>

<style>
  @import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
  body{
    /*font-family: "Helvetica Neue",'Helvetica','Arial','sans-serif';*/
    font-family: "Microsoft YaHei";
  }

</style>



// WEBPACK FOOTER //
// App.vue?82626da2